// @flow

import * as types from '../actionTypes';
import { createAction } from '../utils';

export const updateSessionActions = {
  online: () => createAction(types.SESSION_ONLINE),
  offline: () => createAction(types.SESSION_OFFLINE),
};
